var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.75H10.5C10.75 6.75 11 6.53125 11 6.25V5.75C11 5.5 10.75 5.25 10.5 5.25H5.5C5.21875 5.25 5 5.5 5 5.75V6.25C5 6.53125 5.21875 6.75 5.5 6.75ZM5 9.25C5 9.53125 5.21875 9.75 5.5 9.75H10.5C10.75 9.75 11 9.53125 11 9.25V8.75C11 8.5 10.75 8.25 10.5 8.25H5.5C5.21875 8.25 5 8.5 5 8.75V9.25ZM8 13.0625C7.46875 13.0625 6.96875 12.9063 6.53125 12.5625L0 7.84375V14.5C0 15.3438 0.65625 16 1.5 16H14.5C15.3125 16 16 15.3438 16 14.5V7.84375L9.4375 12.5625C9 12.9063 8.5 13.0625 8 13.0625ZM15.4063 5.09375C15.125 4.90625 14.875 4.6875 14.5 4.40625V3C14.5 2.1875 13.8125 1.5 13 1.5H10.5625C10.4688 1.4375 10.375 1.375 10.2812 1.3125C9.75 0.9375 8.71875 0 8 0C7.25 0 6.21875 0.9375 5.6875 1.3125C5.59375 1.375 5.5 1.4375 5.40625 1.5H3C2.15625 1.5 1.5 2.1875 1.5 3V4.40625C1.09375 4.6875 0.84375 4.90625 0.5625 5.09375C0.21875 5.375 0 5.8125 0 6.28125V6.625L3 8.78125V3H13V8.78125L16 6.625V6.28125C16 5.8125 15.7813 5.40625 15.4063 5.09375Z",
    fill: "#1B130E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e6dd30a163797a524035ea6f3bbb23eb.svg";
export { ForwardRef as ReactComponent };